module.exports = __webpack_public_path__ + "img/cuarto creciente.da6e3dc2.png";